import styled from 'styled-components';

import animatedContent from '@kiosk/common/helpers/animatedContent';

export const ViewTasksContainer = styled.div<{ delay: number }>`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  ${animatedContent}
`;
